const rootArea = "/operations";

export const INVENTORY_OPERATIONS = {
	attestation: "ATTESTATION" as const,
	set: "SET" as const,
	reset: "RESET" as const
};

export type InventoryOperationTypes = typeof INVENTORY_OPERATIONS[keyof typeof INVENTORY_OPERATIONS];

export const operationsGlob = (baseArea: string) => ({
	self: `${baseArea}${rootArea}`,
	byOperation: (operationType: InventoryOperationTypes) => ({
		self: `${baseArea}${rootArea}/${operationType}`,
		read: `${baseArea}${rootArea}/${operationType}/read`,
		create: `${baseArea}${rootArea}/${operationType}/create`
	})
});